import { Suspense, useState } from 'react';
import Header from '../ui/header';
import SideDrawer from '../ui/sideDrawer';
import { Toaster } from '../ui/toaster';
import { Outlet } from 'react-router-dom';
// import useUserInfo from '../Authenticate/useUserInfo';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LayoutProps = { userInfo?: any, userPermissions?: any, protectedRoutes?: boolean };

const Layout: React.FC<LayoutProps> = ({ userInfo, userPermissions, protectedRoutes = false }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div className="h-screen">
      {protectedRoutes ? (
        <>
          <Header
            userInfo={userInfo || undefined}
            userPermissions={userPermissions}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
          <div className="flex">
            {isDrawerOpen && (
              <SideDrawer/>
            )}
          </div>
          <div className="h-screen ml-0" style={{ paddingTop: '61px' }} onClick = {() => setIsDrawerOpen(false)}>
            <Suspense fallback={<h4>Loading content...</h4>}>
              <div className="bg-periwinkle-20 h-full">
                <Outlet />
              </div>
            </Suspense>
          </div>
          <Toaster />
        </>
      ) : (
        <div className="h-screen bg-periwinkle-20">
          <Outlet />
        </div>
      )}
    </div>
  );
};

export default Layout;
